import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import { canSeeEaConnect } from '../eaConnect';

// types
import { GuardProps } from 'types/auth';
import Loader from '../../components/Loader';

// ==============================|| EA CONNECT GUARD ||============================== //
// Keeps /ea-connect/* off-limits while the rollout is concealed.
//
// The sidebar group is hidden by the same canSeeEaConnect predicate
// (menu-items/index), but a hidden nav item is not a gate: without this the
// pages stayed reachable by typing the URL or following an old link. Both
// surfaces must read the same predicate or the rollout leaks.

const EaConnectGuard = ({ children }: GuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    if (!canSeeEaConnect(user?.roles)) {
      navigate('/dashboard', { replace: true });
    } else {
      setIsChecking(false);
    }
  }, [isAuthenticated, navigate, user]);

  if (isChecking) {
    return <Loader />;
  }

  return children;
};

export default EaConnectGuard;
